import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, BellRing } from "lucide-react";
import { useT } from "../../lib/i18n";
import { PropertySearchBar } from "../search/PropertySearchBar";

const HERO = "https://customer-assets-jt897jd0.emergentagent.net/job_ad0cee43-adb9-42e2-b070-e52d3c5da298/artifacts/tybtsbq4_Neoklassieke%20Villa%20aan%20het%20Zwembad.png";

export const HeroSection = () => {
  const { t } = useT();

  return (
    <section className="relative overflow-hidden bg-navy">
      {/* architectural backdrop */}
      <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
      {/* Uniform navy overlay for legibility — not a directional gradient */}
      <div className="absolute inset-0 bg-navy/85" />
      <div className="grid-overlay pointer-events-none absolute inset-0 opacity-40" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 py-10 sm:px-6 sm:py-16 lg:grid-cols-[1.35fr_0.65fr] lg:py-24">
        {/* left: copy + Funda-style search */}
        <div>
          <div className="max-w-3xl">
            <h1 className="font-display text-3xl font-extrabold leading-[1.1] text-white drop-shadow-sm sm:text-5xl lg:text-6xl">
              {t("home.hero.title")}
            </h1>
            <p className="mt-3 text-sm text-white/80 sm:mt-5 sm:text-lg">{t("home.hero.subtitle")}</p>
          </div>

          <div className="mt-6 sm:mt-8 lg:-mr-8 xl:-mr-16">
            <PropertySearchBar variant="hero" defaultMode="huur" />
          </div>
          <Link to="/register" data-testid="hero-register-link" className="mt-3 inline-block text-sm font-semibold text-white/80 underline-offset-4 hover:underline sm:mt-4">
            {t("home.hero.cta2")} →
          </Link>
        </div>

        {/* right: floating glass cards over the architecture */}
        <div className="relative hidden h-[420px] lg:block">
          <div className="glass absolute right-6 top-6 flex items-center gap-3 rounded-2xl px-4 py-3 shadow-2xl">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-success text-sm font-extrabold text-white">
              93%
            </span>
            <div>
              <div className="font-display text-sm font-bold text-navy">{t("hero.card.match")}</div>
              <div className="text-xs text-slate-500">{t("hero.card.matchSub")}</div>
            </div>
          </div>
          <div className="glass absolute left-4 top-36 flex items-center gap-3 rounded-2xl px-4 py-3 shadow-2xl">
            <span className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-brandblue text-white">
              <BellRing size={20} />
              <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-white bg-orange-500" />
            </span>
            <div>
              <div className="font-display text-sm font-bold text-navy">{t("hero.card.alert")}</div>
              <div className="text-xs text-slate-500">{t("hero.card.alertSub")}</div>
            </div>
          </div>
          <div className="glass absolute bottom-6 right-10 flex items-center gap-3 rounded-2xl px-4 py-3 shadow-2xl">
            <ShieldCheck size={22} className="text-brandblue" />
            <div>
              <div className="font-display text-sm font-bold text-navy">{t("hero.card.scam")}</div>
              <div className="text-xs text-slate-500">{t("hero.card.scamSub")}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
